import React, {useCallback, useEffect, useState} from "react"
import {Button, Grid, TextField} from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarFilterButton, GridToolbarQuickFilter
} from "@mui/x-data-grid";
import { Typography } from "@material-ui/core";
import {getData, postData} from "../util/__fetch";

const FNOStrategy = ({ user, setOpen, wm }) => {
  const [strategies, setStrategies] = useState([])
  const [exitPercentage, setExitPercentage] = useState(100)

  function CustomToolbar() {
    return (
      <GridToolbarContainer title="Data" sx={{ justifyContent: 'space-between' }}>
        <Typography variant="h6">Open Strategies</Typography>
        <GridToolbarFilterButton />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }
  const setErrorMessage = useCallback((err) => {
    wm(err?.message || err?.toString() || 'Some error occurred')
    setOpen(true)
  }, [setOpen, wm])

  const squareOffStrategy = (multiLegId) => {
    postData(`/algo-trading/api/fno/square-off-strategy/${multiLegId}/${exitPercentage}`, user,
      {}, () => {}, setErrorMessage, () => {})
  }

  const getStrategies = useCallback(() => {
    getData('/algo-trading/api/fno/open-strategies', user, setStrategies, setErrorMessage, () => {})
      . then(r => {});
  }, [user, setErrorMessage]);

  useEffect(() => {
    const interval = setInterval(() => {
      getStrategies()
    }, 5000);

    return () => clearInterval(interval);
  }, [user, getStrategies]);

  const columns = [
    { field: 'multiLegId', headerName: 'Id', width: 120, type: 'number' },
    { field: 'count', headerName: 'Trade #', width: 80, type: 'number' },
    { field: 'tradeStrategy', headerName: 'Strategy', width: 200, valueGetter: (params) => params.row?.tradeStrategy?.replaceAll('FNO_', '')
        ?.replaceAll('MANUAL', 'MAN')?.replaceAll('ISH', '') },
    { field: 'symbols', headerName: 'Symbols', width: 500,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', overflow: 'auto' }}>
          {params?.value}
        </div>
      )
    },
    { field: 'users', headerName: 'Users', width: 200,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', overflow: 'auto' }}>
          {params?.value}
        </div>
      )
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      sortable: false,
      renderCell: ({ row }) =>
        <Button onClick={() => squareOffStrategy(row?.multiLegId)}>
          Square Off
        </Button>,
    },
  ];
  return (
    <Grid item>
      <Grid item justifySelf="center" xs={12}>
        <TextField label="% Exit" variant="outlined" size="small"
                   defaultValue={100} type="number" style={{ marginBottom: '10px' }}
                   onChange={(e) => setExitPercentage(Number.parseFloat(e.target.value))} />
      </Grid>
      <Grid item>
      <DataGrid
        autoHeight={true}
        getRowHeight={() => 'auto'}
        getRowId={(row) => row?.multiLegId}
        rows={strategies}
        columns={columns}
        slots={{
          toolbar: CustomToolbar
        }}
        initialState={{
          sorting: {
            sortModel: [{ field: 'multiLegId', sort: 'asc' }]
          },
          pagination: {
            paginationModel: { page: 0, pageSize: 50 },
          },
        }}
        pageSizeOptions={[50, 100, 150, 200]}
      />
    </Grid>
    </Grid>
  )
}

export default FNOStrategy